import { createContext } from 'react';
import { noop } from 'ramda-adjunct';
export const InfoDialogContext = createContext({
    props: {},
    setProps: noop,
    setOpen: noop,
});
//# sourceMappingURL=infoDialogContext.js.map